/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCloudAccountVolumeSizesResponse
 */
export interface GetCloudAccountVolumeSizesResponse {
    /**
     * 
     * @type {{ [key: string]: number | undefined; }}
     * @memberof GetCloudAccountVolumeSizesResponse
     */
    volumes: { [key: string]: number | undefined; };
}

export function GetCloudAccountVolumeSizesResponseFromJSON(json: any): GetCloudAccountVolumeSizesResponse {
    return GetCloudAccountVolumeSizesResponseFromJSONTyped(json, false);
}

export function GetCloudAccountVolumeSizesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCloudAccountVolumeSizesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'volumes': json['volumes'],
    };
}

export function GetCloudAccountVolumeSizesResponseToJSON(value?: GetCloudAccountVolumeSizesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'volumes': value.volumes,
    };
}


